module.exports = __webpack_public_path__ + "common/sidebar/icon-phone-square-56108dce52a58dda639558a0d045abe1.svg";